// import React, { useState } from "react";
// // material ui
// import {
//   Box,
//   Tabs,
//   Tab,
//   Card,
//   MenuItem,
//   Toolbar,
//   useTheme,
// } from "@mui/material";
// import { makeStyles } from "@mui/styles";

// const tabHeight = "40px"; // default: '48px'
// const useStyles = makeStyles((theme) => ({
//   tabsRoot: {
//     minHeight: tabHeight,
//     height: tabHeight,
//     textDecoration: "none",
//     color: "black",
//   },
//   tabRoot: {
//     minHeight: tabHeight,
//     height: tabHeight,
//   },
//   chromeTab: {
//     textDecoration: "none",
//     color: "black",
//   },
//   scrollButtonIcon: {
//     "&:last-child": {
//       color: "white",
//     },
//   },
// }));

// const TabsLayout = ({
//   backgroundColor,
//   value,
//   handleChange,
//   customWidth,
//   tabNames,
//   matchingValue,
//   hoverName,
//   padding,
// }) => {
//   const classes = useStyles();
//   const theme = useTheme();

//   return (
//     // <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//     <Card
//       sx={{
//         boxShadow: "0 4px 8px 0 rgba(0,0,0,.2), 0 6px 20px 0 rgba(0,0,0,.19)",
//         paddingTop: "0px!important",
//         paddingLeft: "0px!important",
//         paddingRight: "0px!important",
//         borderRadius: ".25rem",
//         height: "100%",
//       }}
//       // style={padding && { border: "0.5rem solid white" }}
//     >
//       <Toolbar
//         disableGutters
//         sx={{
//           minHeight: "2.5rem !important",
//           backgroundColor: backgroundColor ? "#363531" : "#262626",
//           borderRadius: "5px",
//           alignItems: "flex-end",
//         }}
//       >
//         <Tabs
//           value={value}
//           onChange={handleChange}
//           aria-label="basic tabs example"
//           sx={{
//             backgroundColor: backgroundColor ? "#363531" : "#262626",
//             padding: "0.5rem",
//             paddingBottom: 0,
//             minHeight: "2.5rem !important",
//             "& .MuiTabs-scrollButtons": {
//               color: "#fff", // Set the scroll buttons color to white
//             },
//           }}
//           TabIndicatorProps={{
//             style: {
//               display: "none", // Hides the bottom indicator line
//             },
//           }}
//           variant="scrollable"
//           scrollButtons="auto"
//           classes={{ scrollButton: classes.scrollButton }}
//         >
//           {tabNames?.length > 0 &&
//             tabNames?.map((item, i) => {
//               const matching = value === matchingValue[i];
//               if (item?.display !== false) {
//                 return (
//                   <Tab
//                     classes={{
//                       root: classes.tabsRoot,
//                     }}
//                     className={matching ? "tab" : ""}
//                     style={{
//                       backgroundColor: matching && "#fff",

//                       borderRadius: "10px",
//                       borderBottomLeftRadius: matching && "0px",
//                       borderBottomRightRadius: matching && "0px",
//                       marginLeft: "1rem",
//                     }}
//                     component={(props) => (
//                       <Box
//                         sx={{
//                           flexGrow: 1,
//                           display: { md: "flex" },
//                           // marginLeft: "7.6rem",
//                           marginLeft: "0.6rem",
//                         }}
//                         onClick={(e) => handleChange(e, matchingValue[i])}
//                         // {...props}
//                       >
//                         <Box
//                           sx={{
//                             backgroundColor: matching && "#fff",
//                             borderRadius: "10px",
//                             borderBottomLeftRadius: matching && "0px",
//                             borderBottomRightRadius: matching && "0px",
//                             marginLeft: "1rem",
//                           }}
//                           className={matching ? "tab" : ""}
//                         >
//                           <MenuItem
//                             sx={{
//                               "&:hover": {
//                                 backgroundColor: matching
//                                   ? "#fff"
//                                   : "rgba(193, 213, 245, 1)",
//                                 borderRadius: "10px",
//                               },
//                               width: item?.customWidth ? item?.customWidth : "10.5rem", //checking for the normal width if it is not sufficient using custom width to adjust the width
//                             }}
//                           >
//                             <div
//                               style={{
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                                 whiteSpace: "nowrap",
//                                 color: matching ? "black" : "white",
//                               }}
//                               title={hoverName ?? item?.name}
//                             >
//                               {item?.name}
//                             </div>
//                           </MenuItem>
//                         </Box>
//                         {/* {props?.children} */}
//                       </Box>
//                     )}
//                   />
//                 );
//               }
//             })}
//         </Tabs>
//       </Toolbar>
//     </Card>
//     // </Box>
//   );
// };

// export default TabsLayout;

// import React, { useEffect, useState } from "react";
// // material ui
import React from "react";

import { Card, Grid, Toolbar, Tabs, Tab, Box } from "@mui/material";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  scrollButton: {
    color: "#262626",
  },

  tabsRoot: {
    minHeight: "2.5rem",
  },
}));

const CustomTabs = ({
  value,
  handleChange,
  tabNames = [],
  matchingValue = [],
  tabIndicatorProps,
  scrollButton,
  customSize = 12,
  paddingTop,
  paddingBottom,
  hoverName,
  children,
}) => {
  const classes = useStyles();

  return (
    <Card
      sx={{
        paddingTop: "0px!important",
        paddingLeft: "0px!important",
        paddingRight: "0px!important",
        borderRadius: ".25rem",
      }}
    >
      <Grid container>
        <Grid
          item
          md={customSize}
          lg={customSize}
          xl={customSize}
          sm={customSize}
          xs={customSize}
          pt={paddingTop}
          pb={paddingBottom}
        >
          <Toolbar
            disableGutters
            sx={{
              minHeight: "2.5rem !important",
              backgroundColor: "white",
              borderRadius: "5px",
              alignItems: "flex-end",
            }}
            className={tabIndicatorProps ? "" : "tabs-bottom-border"}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{
                backgroundColor: "white",
                paddingTop: tabIndicatorProps ? "0px" : "0.5rem",
                marginLeft: "0px",
                paddingBottom: 0,
                minHeight: "2.5rem !important",

                "& .MuiTabs-scrollButtons": {
                  color: "#262626",
                },

                "& .MuiTabs-flexContainer": {
                  paddingRight: "1.25rem",
                },
              }}
              TabIndicatorProps={
                tabIndicatorProps
                  ? {}
                  : {
                      style: {
                        display: "none",
                      },
                    }
              }
              variant="scrollable"
              scrollButtons={scrollButton ? "auto" : "on"}
              classes={{
                scrollButton: classes.scrollButton,
              }}
            >
              {tabNames?.length > 0 &&
                tabNames.map((item, i) => {
                  const matching = value === matchingValue[i];

                  if (item?.display === false) {
                    return null;
                  }

                  return (
                    <Tab
                      key={i}
                      
                      value={matchingValue[i]}
                      onClick={(e) => handleChange(e, matchingValue[i])}
                      classes={{
                        root: classes.tabsRoot,
                      }}
                      className={matching && !tabIndicatorProps ? "tab" : ""}
                      label={
                        <Box
                          sx={{
                            width: item?.customWidth
                              ? item?.customWidth
                              : "13.5rem",

                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textTrasform:"none",
                            color: tabIndicatorProps
                              ? "#262626"
                              : matching
                                ? "#FFF"
                                : "#262626",
                        

                            fontWeight: matching ? 600 : 500,
                          }}
                          title={hoverName ?? item?.name}
                          className={
                            matching
                              ? "tabs-header-font-style-matched"
                              : "tabs-header-font-style"
                          }
                        >
                          {item?.name}
                        </Box>
                      }
                      sx={{
                        width: item?.customWidth
                          ? item?.customWidth
                          : "13.5rem",

                        minWidth: item?.customWidth
                          ? item?.customWidth
                          : "13.5rem",

                        minHeight: "2.5rem",
                        // borderTopLeftRadius: matching && "0.5rem",
                        // borderTopRightRadius: matching && "0.5rem",

                        // padding: 0,

                        display: item?.display === false ? "none" : "flex",

                        backgroundColor: tabIndicatorProps
                          ? matching
                            ? "#E5F2FE"
                            : "transparent"
                          : matching
                            ? "#262626"
                            : "transparent",

                        //   borderRadius: matching
                        //     ? "0.5rem 0.5rem 0 0"
                        //     : "0",

                        borderRadius: "5px",
                        borderBottomLeftRadius: !matching && "5px",
                        borderBottomRightRadius: !matching && "5px",
                        //   borderBottomLeftRadius: !matching ? "0px" : undefined,
                        //   borderBottomRightRadius: !matching ? "0px" : undefined,

                        position: "relative",

                        ...(matching &&
                          !tabIndicatorProps && {
                            WebkitBoxShadow: "-10px 0 0 0 #262626",
                            boxShadow: "-10px 0 0 0 #262626",
                          }),

                        "&:hover": {
                          backgroundColor: tabIndicatorProps
                            ? "#E5F2FE"
                            : matching
                              ? "#262626"
                              : "#E5F2FE",

                          // borderRadius: "0.5rem 0.5rem 0 0",
                        },

                        "&.Mui-selected": {
                          color: tabIndicatorProps ? "#262626" : "#FFF",
                        },
                      }}
                    />
                  );
                })}
            </Tabs>
          </Toolbar>
        </Grid>

        {children && children}

        <Grid item md={0.5} lg={0.5} xl={0.5} sm={0.5} xs={0.5} />
      </Grid>
    </Card>
  );
};

export default CustomTabs;
